import Vue from 'vue'
import vuetify from './plugins/vuetify';
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import VeeValidate from 'vee-validate';
import moment from 'moment';
// import 'moment-timezone';
import VueAxios from 'vue-axios';

import firebase from 'firebase/app'
Vue.use(firebase) 


var config = {
  apiKey: "AIzaSyAqRpGZAj-zorkw8bFOJhYJ_H7tJySR5As",
  authDomain: "marathon-vm.firebaseapp.com",
  databaseURL: "https://marathon-vm.firebaseio.com",
  projectId: "marathon-vm",
  storageBucket: "marathon-vm.appspot.com",
  messagingSenderId: "148256683459",
  appId: "1:148256683459:web:d2fba670e564a41e48f976",
  measurementId: "G-GL8REH789J"
};
firebase.initializeApp(config);

require('./assets/css/style.css');

Vue.config.productionTip = false
window.axios = axios;
window.moment = moment;
Vue.use(VeeValidate)


Vue.use(vuetify, {
  theme:{ 
    primary: "#34657f",
    secondary: "#fff", 
    accent: "#383859", 
    error: "#f44336", 
    warning: "#ff9800", 
    info: "#339999", 
    success: "#4caf50",
    blend: "#ecf1f4",
    icon_color: "#bbbbc6"
  }

});
router.beforeEach(

  (to, from, next) => {


    if(to.matched.some(record => record.meta.forGuests)){
      next();
    } 
    else if(to.matched.some(record => record.meta.forUsers)) 
      {
        if(localStorage.getItem('visitor_management_access_token') === null) {
          next({
            name: 'login',
          })
        }
     else 
        {
          if(!store.getters.get_access_token) {
            store.dispatch('storeAccessToken', localStorage.getItem('visitor_management_access_token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.get_access_token;
            store.dispatch('storePermissions', localStorage.getItem('visitor_management_permissions'));
            store.dispatch('storeUser', JSON.parse(localStorage.getItem('visitor_management_auth_user')))
          }
          next();
        }
      } 
      else next();

  }

);
window.axios.interceptors.response.use(null, function(error) {
  switch(error.response.status) {
      case 401:
          localStorage.clear();
          router.push({ name: 'login', query: {error: 'Session Expired'}});
          break;
      case 403:
        //
          break;
      case 404:
        //
          break;
      case 429:
        //
          break;
      default:
          break;
    }
  return Promise.reject(error);
});
Vue.mixin({
  methods: {
    
    storage_path() {
      return `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_STORAGE_PATH}/`;
    },
    formatDate(date) 
    {
      return moment(date).format('DD-MMM-YYYY')
    },
    formatTime(time) 
    {
      return moment(time, "DD-MMM-YYYY H:mm:ss").format("hh:mm a");
    },
    formatDateTime(date) 
    {
      return moment(date).format('DD-MMM-YYYY hh:mm a')
    },
    download(data,file_name)
    {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href =  url;
      link.setAttribute('download', file_name + Date.now() + '.' + 'csv');
      document.body.appendChild(link);
      link.click();
    },
  }
});

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
});
Vue.filter('TwoDigitNumber', function (value) {
  if (value>10 && value<0) return ''
      value = value.toString()
      return (value < 10 ? '0' : '') + value
});

new Vue({
  router,
  store,
  vuetify,

  render: h => h(App)
}).$mount('#app')
